import React from 'react';

// Adds letter-spacing after the first letter of each target pair, fixing
// cramped or loose letter pairs in the display headings. Only the first match
// of each pair is spaced. `text` must be a plain string.
//   pairs as array  -> uniform `track` for every pair, e.g. pairs={['ly']}
//   pairs as object -> per-pair track, e.g. pairs={{ fo: '0.03em', ll: '-0.03em' }}
export const Kern = ({ text, pairs = [], track = '-0.05em' }) => {
  const map = Array.isArray(pairs)
    ? Object.fromEntries(pairs.map((p) => [p, track]))
    : pairs;
  const marks = {};
  const lower = text.toLowerCase();
  Object.entries(map).forEach(([p, t]) => {
    const i = lower.indexOf(p.toLowerCase());
    if (i !== -1) marks[i] = t; // index of the first letter of the pair
  });
  if (!Object.keys(marks).length) return <>{text}</>;
  return (
    <>
      {[...text].map((ch, i) =>
        marks[i] !== undefined
          ? <span key={i} style={{ letterSpacing: marks[i], fontKerning: 'none', fontFeatureSettings: '"kern" 0' }}>{ch}</span>
          : <React.Fragment key={i}>{ch}</React.Fragment>
      )}
    </>
  );
};
